import WatchingYou from './WatchingYou.js';

const logger = new WatchingYou();
const isUnitTest = process.env.NODE_ENV === 'unit-test';
const isBuildProcess = process.env.NODE_ENV === 'build';
const isLocalhost = !['dev', 'stage', 'prod'].includes(process.env.NODE_ENV);

/* v8 ignore start */

if (!isUnitTest && !isBuildProcess) {
	if (IS_SERVER) {
		const { default: WatchingYouPrometheus } = await import('#backend/util/WatchingYouPrometheus.js');
		logger.addLogger(new WatchingYouPrometheus('CheckoutServer'));
		if (isLocalhost) {
			const { default: WatchingYouConsole } = await import('#backend/util/WatchingYouConsole.js');
			logger.addLogger(new WatchingYouConsole());
		} else {
			const { default: WatchingYouKibana } = await import('#backend/util/WatchingYouKibana.js');
			logger.addLogger(new WatchingYouKibana());
		}
	}
	if (IS_CLIENT) {
		const { default: WatchingYouConsole } = await import('#frontend/util/WatchingYouConsole.js');
		const { default: WatchingYouGA } = await import('#frontend/util/WatchingYouGA.js');
		logger.addLogger(new WatchingYouConsole());
		logger.addLogger(new WatchingYouGA());
	}
}

/* v8 ignore stop */

export default logger;
